import React, { Component } from 'react';
import './App.css';
import Navbar from './Navbar';
import Resume from './resume/Resume';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: false
    }
  }

  componentDidMount() {
    if (window.innerWidth < 769) {
      this.setState({ mobile: true })
    }
  }

  render() {

    return (
      <div className="App">
        <Navbar isMobile={this.state.mobile} />
        <Resume />
      </div>
    );
  }
}

export default App;
